<template>
  <NuxtLink v-bind="formattedProps">
    <slot />
  </NuxtLink>
</template>

<script setup>
import { computed } from "vue";
import { toNuxtLink } from "../utils/toNuxtLink";
const props = defineProps({
  custom: { type: null, required: false },
  to: { type: null, required: false },
  href: { type: null, required: false },
  external: { type: Boolean, required: false },
  target: { type: [String, Object, null], required: false },
  rel: { type: [String, Object, null], required: false },
  noRel: { type: Boolean, required: false },
  prefetchedClass: { type: String, required: false },
  prefetch: { type: Boolean, required: false },
  prefetchOn: { type: [String, Object], required: false },
  noPrefetch: { type: Boolean, required: false },
  trailingSlash: { type: String, required: false },
  activeClass: { type: String, required: false },
  exactActiveClass: { type: String, required: false },
  ariaCurrentValue: { type: String, required: false },
  viewTransition: { type: Boolean, required: false },
  replace: { type: Boolean, required: false }
});
const formattedProps = computed(() => {
  const {
    noPrefetch: _noPrefetch,
    noRel: _noRel,
    target,
    rel,
    ...originalProps
  } = props;
  return {
    ...originalProps,
    to: originalProps.to ? toNuxtLink(originalProps.to) : void 0,
    rel: rel ?? void 0,
    target: target ?? void 0
  };
});
</script>
